import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Badge from './Badge'
import PriceChangesInfo from './PriceChangesInfo'
import { numberToCurrencyFormat } from 'utils/number-format-util'

const PriceComparisonDialogBlock = ({
    testId,
    changesTitle,
    priceResponse,
    transformOrigin,
    popOverData,
    priceIncrease,
    formattedTotal
}) => {
    const { t } = useTranslation()

    return (
        <Box
            sx={{
                p: 6
            }}
        >
            <Typography
                data-testid={`${testId}`}
                data-count={Object.keys(priceResponse)?.length}
                sx={{ pb: 2, maxWidth: { xs: '96%', smd: '100%' } }}
            >
                <Typography
                    tabIndex={0}
                    component="span"
                    sx={{
                        color: 'common.charcoal.main',
                        typography: { xs: 'regularBody1', md: 'regularSubTitle' },
                        lineHeight: '28px'
                    }}
                >
                    {changesTitle}
                </Typography>
                <PriceChangesInfo popOverData={popOverData} transformOrigin={transformOrigin} isTotalPopOver={false} />
            </Typography>
            {priceIncrease?.details?.map((data) => (
                <Box
                    key={data.name}
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        gap: { xs: 2, lg: 16 },
                        py: 2,
                        pl: 4
                    }}
                >
                    <Typography
                        tabIndex={0}
                        display="block"
                        sx={{
                            color: 'common.charcoal.main',
                            textAlign: 'left',
                            textWrap: 'balance',
                            flex: { xs: 1.5, md: 2.1 },
                            typography: { xs: 'regularBody2', md: 'regularBody1' }
                        }}
                        data-testid={`${testId}-label`}
                    >
                        {data?.name}
                        {data?.badge && data.badgeContent && <Badge badgeContent={data.badgeContent}></Badge>}
                    </Typography>

                    <Typography
                        tabIndex={0}
                        alignItems="end"
                        display="block"
                        data-testid={`${testId}-value`}
                        sx={{
                            color: 'common.fordTwilight.main',
                            textAlign: 'right',
                            textWrap: 'balance',
                            flex: 1,
                            typography: { xs: 'regularBody2', md: 'regularBody1' }
                        }}
                    >
                        {numberToCurrencyFormat(data.value)}
                    </Typography>
                </Box>
            ))}

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: { xs: 2, lg: 16 },
                    py: 2.5,
                    pl: 4
                }}
            >
                <Typography
                    tabIndex={0}
                    display="block"
                    sx={{
                        color: 'common.charcoal.main',
                        typography: 'boldBody1'
                    }}
                    data-testid={`${testId}-total-label`}
                >
                    {testId === 'decreases' ? t('total_decreases') : t('total_increases')}
                </Typography>
                <Typography
                    tabIndex={0}
                    alignItems="end"
                    display="block"
                    sx={{
                        color: 'common.fordTwilight.main',
                        typography: 'boldBody1'
                    }}
                    data-testid={`${testId}-total-value`}
                >
                    {numberToCurrencyFormat(formattedTotal)}
                </Typography>
            </Box>
        </Box>
    )
}

PriceComparisonDialogBlock.propTypes = {
    testId: PropTypes.string,
    priceResponse: PropTypes.object,
    popOverData: PropTypes.string,
    changesTitle: PropTypes.string,
    transformOrigin: PropTypes.object,
    formattedTotal: PropTypes.string,
    priceIncrease: PropTypes.object
}

export default PriceComparisonDialogBlock
